<script lang="ts">
import type { DrawerEmits, DrawerSlots, DrawerProps as UDrawerProps } from '#ui/types';

export interface DrawerProps extends UDrawerProps {
	/**
	 * Let the user drag the drawer to close it.
	 *
	 * @default false
	 */
	draggable?: boolean;
}
</script>

<script setup lang="ts">
import { reactiveOmit } from '@vueuse/core';
import { defu } from 'defu';
import { useForwardPropsEmits } from 'reka-ui';
import { computed } from 'vue';
import Drawer from '#ui/components/Drawer.vue';

const props = defineProps<DrawerProps>();
const emits = defineEmits<DrawerEmits>();
const slots = defineSlots<DrawerSlots>();

const forward = useForwardPropsEmits(reactiveOmit(props, 'draggable', 'content'), emits);
const contentProps = computed(() => defu({ 'data-vaul-no-drag': !props.draggable }, props.content) as DrawerProps['content']);
</script>

<template>
	<Drawer v-bind="forward" :content="contentProps" inset>
		<template v-for="(_, name) in slots" #[name]="slotData: any">
			<slot :name v-bind="slotData" />
		</template>
	</Drawer>
</template>
